let local_links = new Array();
export let CanvasList = new Array();

async function LoadHeaderNavigator()
{
  const header_nav = document.getElementsByClassName("header_nav")[0]

  //@NOTE(Emilio): About
  const index_link = document.createElement("a")
  index_link.href = "./index.html"
  index_link.textContent = "About"
  index_link.className = "header_nav_button"
  header_nav.append(index_link)

  //@NOTE(Emilio): Foundation
  const foundation_link = document.createElement("a")
  foundation_link.href = "./foundation.html"
  foundation_link.textContent = "Foundation Zero"
  foundation_link.className = "header_nav_button"
  header_nav.append(foundation_link)

  //@NOTE(Emilio): Projects
  const project_link = document.createElement("a")
  project_link.href = "./project.html"
  project_link.textContent = "Projects"
  project_link.className = "header_nav_button"
  header_nav.append(project_link)

  //@NOTE(Emilio): Bowling
  const bowling_link = document.createElement("a")
  bowling_link.href = "./bowling.html"
  bowling_link.textContent = "Bowling"
  bowling_link.className = "header_nav_button"
  header_nav.append(bowling_link)

  //@NOTE(Emilio): main
  const blog_link = document.createElement("a")
  blog_link.href = "./blog.html"
  blog_link.textContent = "Dev Blogs"
  blog_link.className = "header_nav_button"
  header_nav.append(blog_link)

  //@NOTE(Emilio): main
  const beta_link = document.createElement("a")
  beta_link.href = "./beta.html"
  beta_link.textContent = "Beta"
  beta_link.className = "header_nav_button"
  header_nav.append(beta_link)

  const zep_gh = document.createElement("a")
  zep_gh.href = "https://github.com/EmilioCBen"
  zep_gh.textContent = "Zephyr Github"
  zep_gh.className = "header_nav_button"
  header_nav.append(zep_gh)

  const personal_gh = document.createElement("a")
  personal_gh.href = "https://github.com/EmilioBenavente"
  personal_gh.textContent = "Personal Github"
  personal_gh.className = "header_nav_button"
  header_nav.append(personal_gh)
}

async function LoadLocalNavigationLinks()
{
  const local_page_nav = document.getElementsByClassName("page_nav_element")[0]

  //@NOTE(Emilio): About

  for(let i = 0; i < local_links.length; i++)
  {
    const nav_list_item = document.createElement("li")
    const nav_list_a = document.createElement("a")
    nav_list_a.href = local_links[i]
    nav_list_a.textContent = local_links[i].replace("#", "")
    nav_list_a.className = "page_nav_list_item_link"
    nav_list_item.append(nav_list_a)

    nav_list_item.className = "page_nav_list_item"
    local_page_nav.append(nav_list_item)
  }

}



async function LoadContentForSection(filename)
{
  const main_section = document.getElementById("main_section")
  const fetch_result = await fetch(filename)
  const result_text = await fetch_result.text()
  const result_no_newlines = result_text.replace("/[\r]/g", "")
  const paragraphs = result_no_newlines.split("-???-")

  for(let item_index = 1; item_index < paragraphs.length; item_index++)
  {
    const main_sub_section = document.createElement("section")
    main_sub_section.className = "main_sub_section"

    const sub_paragraphs = paragraphs[item_index].split("\n")
    for(let sub_index = 0; sub_index < sub_paragraphs.length - 1; sub_index++)
    {
      if(sub_paragraphs[sub_index] === "")
      {
        const main_br = document.createElement("p")
        main_br.innerHTML = "<br />"
        main_sub_section.append(main_br)
        continue
      }

      if(sub_paragraphs[sub_index].startsWith("//"))
      {
        continue;
      }

      if(sub_paragraphs[sub_index].startsWith("<img>"))
      {
        const main_sub_img = document.createElement("img")
        main_sub_img.className = "main_media"
        const img_src = sub_paragraphs[sub_index].replace("<img>", "")
        main_sub_img.src = img_src

        main_sub_section.append(main_sub_img)
      }
      else if(sub_paragraphs[sub_index].startsWith("<canvas>"))
      {
        const main_sub_canvas = document.createElement("canvas")
        const canvas_src = sub_paragraphs[sub_index].replace("<canvas>", "")
        const canvas_values = canvas_src.split("/")

        main_sub_canvas.id = canvas_values[0]
        main_sub_canvas.width  = canvas_values[1]
        main_sub_canvas.height = canvas_values[2]
        CanvasList.push(main_sub_canvas)

        main_sub_section.append(main_sub_canvas)
      }
      else if(sub_paragraphs[sub_index].startsWith("<a>"))
      {
        const main_sub_a = document.createElement("a")
        const a_src = sub_paragraphs[sub_index].replace("<a>", "")
        const a_values = a_src.split("@@@")

        main_sub_a.className="main_a"
        main_sub_a.href = a_values[0]
        main_sub_a.textContent = a_values[1]
        main_sub_a.target = "_blank"

        main_sub_section.append(main_sub_a)
      }
      else if(sub_paragraphs[sub_index].startsWith("<h>"))
      {
        const main_sub_h = document.createElement("h")
        main_sub_h.className = "main_header"
        const h_src = sub_paragraphs[sub_index].replace("<h>", "")
        main_sub_h.textContent = h_src
 
        main_sub_section.append(main_sub_h)
      }
      else if(sub_paragraphs[sub_index].startsWith("<video>"))
      {
        const main_sub_video = document.createElement("video")
        main_sub_video.className = "main_media"
        main_sub_video.controls = true
        const video_src = sub_paragraphs[sub_index].replace("<video>", "")
        main_sub_video.src = video_src
 
        main_sub_section.append(main_sub_video)
      }
      else if(sub_paragraphs[sub_index].startsWith("<id>"))
      {
        const id_src = sub_paragraphs[sub_index].replace("<id>", "")
        main_sub_section.id = id_src

        local_links.push(`#${id_src}`)
      }
      else
      {
        const main_sub_p = document.createElement("p")
        main_sub_p.textContent = sub_paragraphs[sub_index]
        main_sub_p.className = "main_p"
        main_sub_section.append(main_sub_p)
      }
    }

    main_section.append(main_sub_section)
  }
}

async function LoadContentForFooter()
{
  const footer_update = document.getElementsByClassName("footer_right")[0]
  footer_update.textContent = "Last Updated: 2026-05-03"
}

async function PageGeneration()
{
  await LoadHeaderNavigator()
  let filename = "./" + window.location.pathname.split('/').pop().split('.')[0] + ".txt"
  if(filename == "./.txt")
  {
    filename = "index.txt"
  }
  await LoadContentForSection("./" + filename)
  await LoadLocalNavigationLinks()
  await LoadContentForFooter()

  const content_loaded_event = new CustomEvent("contentLoaded")
  window.dispatchEvent(content_loaded_event)
}

const local_links_button = document.getElementsByClassName("page_nav_wrapper")[0]
local_links_button.onclick = () => {
  const local_links_list = document.getElementsByClassName("page_nav_list")[0]
  if(local_links_list.style.display == "block")
  {
    local_links_list.style.display = ""
  }
  else
  {
    local_links_list.style.display = "block"
  }
};

PageGeneration()
